export default {
  regionOptions: [
    'Africa',
    'Alaska',
    'Australasia',
    'Australia',
    'Caribbean',
    'Mediterranean',
    'Middle East',
    'Northern Europe',
    'South America',
    'South Sea',
    'United States of America'
  ],
  cruiseLineOptions: [
    'Royal Caribbean Cruises',
    'Princess',
    'Celebrity',
    'Norwegian Cruise Lines',
    'Carnival'
  ],
  cabinTypeOptions: ['Interior', 'Oceanview', 'Balcony', 'Suite'],
  amenityOptions: [
    'Service',
    'Food and Beverage',
    'Cabins',
    'Onboard Facilities',
    'Wifi',
    'Entertainment',
    'Onboard Activities',
    'Shore Excursions',
    'Value for Money'
  ]
}
